import { Injectable } from '@angular/core';
import { BaseApi } from '../../base-api.service';
import { Observable, map, of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AddCustomerService {

  private baseUrl = '/users';

  constructor(
    private api: BaseApi,
  ) { }

  private relations = [
    { id: 1, name: 'Partner' },
    { id: 2, name: 'Director' },
    { id: 3, name: 'Husband' },
    { id: 4, name: 'Wife' },
    { id: 5, name: 'Father' },
    { id: 6, name: 'Mother' },
    { id: 7, name: 'Son' },
    { id: 8, name: 'Brother' },
    { id: 9, name: 'Sister' },
    { id: 10, name: 'Other' },
    { id: 11, name: 'Proprietor' },
    { id: 12, name: 'Authorised Signatory' },
    { id: 13, name: 'Karta ' },
  ];

  private idTypes = [
    { id: 1, name: 'Aadhaar Card', value: 'aadhar' },
    { id: 2, name: 'PAN', value: 'pan' },
    { id: 3, name: 'DL', value: 'driver license' },
    { id: 4, name: 'Voter ID', value: 'voter id' },
    { id: 5, name: 'Passport', value: 'passport id' },
  ];

  private retaionshipType = [
    { id: 1, name: 'Father', value: 'father' },
    { id: 2, name: 'Husband', value: 'husband' },
    { id: 3, name: 'Son', value: 'son' },
    { id: 4, name: 'Brother', value: 'brother' },
    { id: 5, name: 'Mother', value: 'mother' },
    { id: 5, name: 'Wife', value: 'wife' },
    { id: 5, name: 'Daughter', value: 'daughter' },
    { id: 5, name: 'Sister', value: 'sister' },
  ];
  private relationsGuar = [
    { id: 1, name: 'Partner' },
    { id: 2, name: 'Director' },
    { id: 3, name: 'Husband' },
    { id: 4, name: 'Wife' },
    { id: 5, name: 'Father' },
    { id: 6, name: 'Mother' },
    { id: 7, name: 'Son' },
    { id: 8, name: 'Brother' },
    { id: 9, name: 'Sister' },
    { id: 10, name: 'Other' },
  ]

  private category = [
    { id: 5, name: 'Individual' },
    { id: 1, name: 'Proprietory' },
    { id: 2, name: 'Partnership' },
    { id: 3, name: 'LLP' },
    { id: 4, name: 'Private Limited' },
    // { id: 5, name: 'Public Limited' },
    // { id: 6, name: 'HUF' },
    // { id: 7, name: 'Trust' },
    // { id: 8, name: 'Society' },
    // { id: 9, name: 'AOP' },

  ];

  private segment = [
    { id: 1, name: "Health Care" },
    { id: 2, name: "Non-Health Care/ PLM" },
    { id: 3, name: "Doctor Loans" },
    { id: 4, name: "Non-Healthcare up to EUR 35k" }
  ];

  private category_SM = [
    { id: 1, name: 'Health Care' },
    { id: 2, name: 'Non-Health Care/ PLM' },
    { id: 3, name: 'Doctor Loans' },
    { id: 4, name: 'Non-Healthcare up to EUR 35K' },
  ];

  private subcategory_SM = [
    { id: 1, catid: [1, 2, 4], name: 'Individual' },
    { id: 2, catid: [1, 2, 4], name: 'Proprietary' },
    { id: 3, catid: [1, 2, 4], name: 'Partnership' },
    { id: 4, catid: [1, 2, 4], name: 'LLP' },
    { id: 5, catid: [1, 2, 4], name: 'Private Limited' },
  ];

  private subcategory_1_SM = [
    { id: 6, catid: [3], name: 'Individual' },
    { id: 1, catid: [3], name: 'Proprietary' },
    { id: 2, catid: [3], name: 'Partnership' },
    { id: 3, catid: [3], name: 'LLP' },
    { id: 4, catid: [3], name: 'Private Limited' },

  ];

  private Sales_User = [
    { id: 1, roleId: [1], name: 'Mahesh' },
    { id: 2, roleId: [2], name: 'Prashanth' },
    { id: 3, roleId: [3], name: 'Vinod' },
  ];

  // private category = [
  //   { id: 1, name: 'Company'},
  //   { id: 2, name: 'HUF' },
  //   { id: 3, name: 'Individual' },
  //   { id: 4, name: 'LLP' },
  //   { id: 5, name: 'Partnership' },
  //   { id: 6, name: 'Proprietorship' },
  //   { id: 7, name: 'Private Limited' },
  //   { id: 8, name: 'Public Limited' },
  // ];

  private subcategory = [
    { id: 1, name: 'Category 1' },
    { id: 2, name: 'Category 2' },
    { id: 3, name: 'Category 3' },
    { id: 4, name: 'Super Strategic' },
    { id: 5, name: 'Strategic' },
    { id: 6, name: 'High End Retail' },
    { id: 7, name: 'Retail' },
    { id: 8, name: 'Retail - 3 to 10' },
    { id: 9, name: 'SVO' },
    { id: 10, name: 'FTU' },
    { id: 11, name: 'Large Grade 1' },
    { id: 12, name: 'Large Grade 2' },
    { id: 13, name: 'Large Grade 3' },
  ];

  private pslcategory = [
    { id: 1, name: 'Yes' },
    { id: 2, name: 'No' },
  ]

  private status = [
    { id: 1, name: 'Sourcing / Negotiation' },
    { id: 2, name: 'Lead Created' },
    { id: 3, name: 'Credit in Process' },
    { id: 4, name: 'Sanctioned' },
    { id: 5, name: 'Documentation in Process' },
    { id: 6, name: 'DO in Process' },
    { id: 7, name: 'DO Issued' },
    { id: 8, name: 'PDD in Process' },
    { id: 9, name: 'Disbursed' },
  ]

  private state = [
    { id: 'AP', name: 'Andhra Pradesh' },
    { id: 'AD', name: 'ANDHRA PRADESH (NEW)' },
    { id: 'AR', name: 'Arunachal Pradesh' },
    { id: 'AS', name: 'Assam' },
    { id: 'BH', name: 'Bihar' },
    { id: 'CT', name: 'Chattisgarh' },
    { id: 'GA', name: 'Goa' },
    { id: 'GJ', name: 'Gujarat' },
    { id: 'HR', name: 'Haryana' },
    { id: 'HP', name: 'Himachal Pradesh' },
    { id: 'JK', name: 'Jammu & Kashmir' },
    { id: 'JH', name: 'Jharkhand' },
    { id: 'KA', name: 'Karnataka' },
    { id: 'KL', name: 'Kerala' },
    { id: 'MP', name: 'Madhya Pradesh' },
    { id: 'MH', name: 'Maharashtra' },
    { id: 'MN', name: 'Manipur' },
    { id: 'ME', name: 'Meghalaya' },
    { id: 'MI', name: 'Mizoram' },
    { id: 'NL', name: 'Nagaland' },
    { id: 'OR', name: 'ODISHA' },
    { id: 'PB', name: 'Punjab' },
    { id: 'RJ', name: 'Rajasthan' },
    { id: 'SK', name: 'Sikkim' },
    { id: 'TN', name: 'Tamil Nadu' },
    { id: 'TS', name: 'Telangana' },
    { id: 'TR', name: 'Tripura' },
    { id: 'UT', name: 'Uttarakhand' },
    { id: 'UP', name: 'Uttar Pradesh' },
    { id: 'WB', name: 'West Bengal' },
    { id: 'AN', name: 'Andaman & Nicobar' },
    { id: 'CH', name: 'Chandigarh' },
    { id: 'DN', name: 'Dadra and Nagar Haveli' },
    { id: 'DD', name: 'Daman & Diu' },
    { id: 'DL', name: 'Delhi' },
    { id: 'LD', name: 'LAKSHADWEEP ISLANDS' },
    { id: 'PY', name: 'Pondicherry' },
  ];

  private states = [
    { id: 'AN', name: 'ANDAMAN AND NICOBAR ISLANDS' },
    { id: 'AP', name: 'ANDHRA PRADESH' },
    { id: 'AD', name: 'ANDHRA PRADESH (NEW)' },
    { id: 'AR', name: 'ARUNACHAL PRADESH' },
    { id: 'AS', name: 'ASSAM' },
    { id: 'BH', name: 'BIHAR' },
    { id: 'CH', name: 'CHANDIGARH' },
    { id: 'CT', name: 'CHATTISGARH' },
    { id: 'DN', name: 'DADRA AND NAGAR HAVELI' },
    { id: 'DD', name: 'DAMAN AND DIU' },
    { id: 'DL', name: 'DELHI' },
    { id: 'GA', name: 'GOA' },
    { id: 'GJ', name: 'GUJARAT' },
    { id: 'HR', name: 'HARYANA' },
    { id: 'HP', name: 'HIMACHAL PRADESH' },
    { id: 'JK', name: 'JAMMU & KASHMIR' },
    { id: 'JH', name: 'JHARKHAND' },
    { id: 'KA', name: 'KARNATAKA' },
    { id: 'KL', name: 'KERALA' },
    { id: 'LD', name: 'LAKSHADWEEP ISLANDS' },
    { id: 'MP', name: 'MADHYA PRADESH' },
    { id: 'MH', name: 'MAHARASHTRA' },
    { id: 'MN', name: 'MANIPUR' },
    { id: 'ME', name: 'MEGHALAYA' },
    { id: 'MI', name: 'MIZORAM' },
    { id: 'NL', name: 'NAGALAND' },
    { id: 'OR', name: 'ODISHA' },
    { id: 'PY', name: 'PONDICHERRY' },
    { id: 'PB', name: 'PUNJAB' },
    { id: 'RJ', name: 'RAJASTHAN' },
    { id: 'SK', name: 'SIKKIM' },
    { id: 'TN', name: 'TAMIL NADU' },
    { id: 'TS', name: 'TELANGANA' },
    { id: 'TR', name: 'TRIPURA' },
    { id: 'UP', name: 'UTTAR PRADESH' },
    { id: 'UT', name: 'UTTARAKHAND' },
    { id: 'WB', name: 'WEST BENGAL' },
  ];

  private financer = [
    { id: 1, name: 'Axis Bank' },
    { id: 2, name: 'HDB' },
    { id: 3, name: 'Hinduja Leyland Finance' },
    { id: 4, name: 'ICICI Bank' },
    { id: 5, name: 'Indusind Bank Ltd' },
    { id: 6, name: 'Kotak Mahindra Finance' },
    { id: 7, name: 'Mahindra' },
    { id: 8, name: 'Tata Capital' },
    { id: 9, name: 'TBA' },
    { id: 10, name: 'Yes Bank' }
  ]

  // private financer = [
  //   { id: 1, name: 'ICICI Bank'},
  //   { id: 2, name: 'Yes Bank'},
  //   { id: 3, name: 'HDB'},
  //   { id: 4, name: 'Mahindra'},
  //   { id: 5, name: 'Axis Bank'},
  //   { id: 6, name: 'TBA'},
  // ]

  private product = [
    { id: 1, name: 'CE - New' },
    { id: 2, name: 'CE - Used' },
    { id: 3, name: 'CV - New' },
    { id: 4, name: 'CV - Used' },
    { id: 5, name: 'Top Up' },
  ]

  private assetCat = [
    { id: 1, name: 'Air Compressor' },
    { id: 2, name: 'Backhoe Loader' },
    { id: 3, name: 'Batching Plant' },
    { id: 4, name: 'Boom Placer' },
    { id: 5, name: 'Boomer' },
    { id: 6, name: 'Bulker' },
    { id: 7, name: 'Bulldozer' },
    { id: 8, name: 'Bus' },
    { id: 9, name: 'Car' },
    { id: 10, name: 'Chassis' },
    { id: 11, name: 'Compactor' },
    { id: 12, name: 'Compressor' },
    { id: 13, name: 'Concrete Mixer' },
    { id: 14, name: 'Concrete Pump' },
    { id: 15, name: 'Crane' },
    { id: 16, name: 'Crusher Plant' },
    { id: 17, name: 'DG Set' },
    { id: 18, name: 'Drill Machine' },
    { id: 19, name: 'Dumper' },
    { id: 20, name: 'Excavator' },
    { id: 21, name: 'Forklift' },
    { id: 22, name: 'Hot Mix Plant' },
    { id: 23, name: 'Milling Machine' },
    { id: 24, name: 'Motor Grader' },
    { id: 25, name: 'Paver' },
    { id: 26, name: 'Piling Rig' },
    { id: 27, name: 'Reach stacker' },
    { id: 28, name: 'Road Roller' },
    { id: 29, name: 'Rock Breaker' },
    { id: 30, name: 'Skid Loader' },
    { id: 31, name: 'Soil Compactor' },
    { id: 32, name: 'Surface Miner' },
    { id: 33, name: 'Sweeping Machine' },
    { id: 34, name: 'Tandem Roller' },
    { id: 35, name: 'Tanker' },
    { id: 36, name: 'Tipper' },
    { id: 37, name: 'Tractor Trailer' },
    { id: 38, name: 'Transit Mixer' },
    { id: 39, name: 'Truck' },
    { id: 40, name: 'Wet Mix Plant' },
    { id: 41, name: 'Wheel Loader' },
    { id: 42, name: 'Other' },

  ]

  private Vehicle_Sub_Type = [
    { codeType: "01", type: "Car - New" },
  ];

  private Vehicle_Sub_Type_1 = [
    { codeType: "01", type: "Car - New" },
    { codeType: "02", type: "Car - II Hand" },
  ];

  private Vehicle_Sub_Type_2 = [
    { codeType: "03", type: "Two Wheeler - New" },
    { codeType: "04", type: "Two Wheeler II Hand" },
  ];

  private application_type = [
    { id: 1, name: 'Retail Loans' },
    { id: 2, name: 'Farmer Loans - KCC' },
  ]

  private retail_loan = [
    { id: 1, name: 'Home Loan' },
    { id: 2, name: 'LAP' },
    { id: 3, name: 'Education Loan' },
    { id: 4, name: 'Car Loan' },
    { id: 5, name: 'Two Wheeler Loan' },
    { id: 6, name: 'Personal Loan' },
    { id: 7, name: 'Gold Loan' },
  ]

  private farmer_loan = [
    { id: 1, name: 'Upto 50K' },
    { id: 2, name: 'Upto 2Lac' },
    { id: 3, name: 'Above 2Lac' },
  ]


  getVehicleLoanSubType(type) {
    if (type == 1 || type == 2 || type == 3) {
      return of(this.Vehicle_Sub_Type);
    } else if (type == 1 || type == 2 || type == 3) {
      return of(this.Vehicle_Sub_Type_1);
    } else if (type == 1 || type == 2 || type == 3) {
      return of(this.Vehicle_Sub_Type_2);
    } else {
      return of({})
    }
  }

  updateSegmentCustType(data) {
    return this.api.postData(`/v1/customer/updateSegment`, data).pipe(
      map(data => {
        return data;
      })
    )
  }

  reassignsalesUser(data) {
    return this.api.postData('/v1/msme/reassignUser', data).pipe(map(data => {
      return data;
    }))
  }

  addCustomer(admin) {
    return this.api.postData(`/v1/customer/porfileCreation`, admin).pipe(
      map(data => {
        return data;
      })
    )
  }

  orderCreation(data) {
    return this.api.postData(
      `/v1/paymentGateway/createOrder`,
      data
    ).pipe(map(res => res));
  }

  verifyPayment(paymentData: any): Observable<any> {
    return this.api.postData(
      '/v1/dfid/razorPayCallBack'
      , paymentData);
  }

  getPaymentStatus(paymentData: any): Observable<any> {
    return this.api.postData('/v1/paymentGateway/getPaymentStatus', paymentData);
  }



  consentWithdrawl(data) {

    let applicantId = sessionStorage.getItem("appId");
    return this.api.postData('/v1/customerDashboard/consentWithdrawal', { "applicantId": applicantId, "isConsentTaken": data }).pipe(map(data => {
      return data;
    }))
  }


  addProfile(profile) {
    return this.api.postData('/v1/customer/porfileCreation', profile).pipe(
      map(data => {
        return data;
      })
    )
  }

  
  addProfileApex(profile) {
    return this.api.postData('/v1/customer/profileCreationApex', profile).pipe(
      map(data => {
        return data;
      })
    )
  }

  addprofilekgb(profile) {
    return this.api.postData('/v1/customer/profileCreationKGB', profile).pipe(
      map(data => {
        return data;

      }
      ))
  }


  addApcobProfile(profile) {
    return this.api.postData('/v1/customer/apcobProfileCreation', profile).pipe(
      map(data => {
        return data;
      })
    )
  }



  panVerify(pan) {
    return this.api.postData('/v1/customer/panCheck', pan).pipe(
      map(data => {
        return data;
      })
    )
  }

  getCoAppCount(custId) {
    return this.api.postData('/v1/customer/porfileCreation', { custId: custId }).pipe(
      map(data => {
        return data;
      })
    )
  }


  applyForLoan(data) {
    return this.api.postData('/v1/autoFill/applyForLoan', data).pipe(
      map(data => {
        return data;
      })
    )
  }

  getProfile(appId) {
    return this.api.getComplt(`/v1/customer/getProfile/${appId}`).pipe(map(res => {

      return res;
    }));
  }

  getRelations() {
    return of(this.relations);
  }

  getRelationsGuar() {
    return of(this.relationsGuar);
  }

  getCat() {
    return of(this.category);
  }

  getSubCat() {
    return of(this.subcategory);
  }


  getCatSM() {
    return of(this.category_SM);
  }

  getSubCatSM() {
    return of(this.subcategory_SM);
  }


  getSubCat1() {
    return of(this.subcategory_1_SM);
  }

  getSeg() {
    return of(this.segment);
  }

  getSubCat_1(value1) {
    return of(this.subcategory_1_SM.filter((value) => value.catid.indexOf(value1) >= 0));
  }

  getSubCat2(value1) {
    return of(this.subcategory_SM.filter((value) => value.catid.indexOf(value1) >= 0));
  }

  getPslCat() {
    return of(this.pslcategory);
  }

  getStatus() {
    return of(this.status);
  }

  getFinancer() {
    return of(this.financer);
  }

  getAssetCat() {
    return of(this.assetCat);
  }

  getProduct() {
    return of(this.product);
  }

  getSalesUser() {

    return of(this.Sales_User);
  }

  getIdType() {
    return of(this.idTypes);
  }

  getRelationType() {
    return of(this.retaionshipType);
  }

  getAppCount() {
    return this.api.postData('/users/getAppCount', "").pipe(
      map(data => {
        return data;
      })
    )
  }

  getGuarantorCount(custId) {
    return this.api.postData('/users/getGuarantorCount', { custId: custId }).pipe(
      map(data => {
        return data;
      })
    )
  }

  getGroupManagers() {
    return this.api.getComplt(`${this.baseUrl}/getGroupSalesManagers`);
  }

  getCustId(obj) {
    return this.api.postData('/v1/customer/custid', obj).pipe(
      map(data => {
        return data;
      })
    )
  }

  setCountValue(obj) {
    return this.api.put('/applicants/customer', obj).pipe(
      map(data => {
        return data;
      })
    )
  }


  getUsers(input, roleId, page, limit, name, entityName, view?) {
    const viewParam = view ? `&view=${encodeURIComponent(view)}` : "";
    return this.api.getComplt(`/v1/customer/getCustomer?page=${page}&limit=${limit}&role=${roleId}&projectName=${name}&adminId=${sessionStorage.getItem('adminId')}&entityName=${entityName}${viewParam}`)
      // return this.api.getComplt(`/v1/customer/getCustomer?page=${page}&limit=${limit}&adminId=${sessionStorage.getItem('adminId')}`)
      .pipe(
        map(data => {
          return data;
        })
      )



  }

  getUsersSearch(input, roleId, name, page, limit, search, view?) {
    const viewParam = view ? `&view=${encodeURIComponent(view)}` : "";
    return this.api.getComplt(`/v1/customer/getCustomer?page=${page}&limit=${limit}&searchQuery=${encodeURIComponent(search || "")}&role=${roleId}&projectName=${name}${viewParam}`).pipe(
      map(data => {
        return data;
      })
    )
  }





  getPlantCode() {
    return this.api.getComplt(`/sftp/plant_code/0`);
  }

  getMccCode(plantCode) {
    return this.api.getComplt(`/sftp/plant_code/${plantCode}`);
  }

  read(fd: FormData, type) {
    console.log(fd)
    fd.append('applicantId', this.getApplicantID());
    // const file = fd.get('file');
    // fd.delete('imgFile ');
    // fd.set('imgFile', file);
    fd.append('imageType', type);


    console.log(fd, "Formdata")
    return this.api.postData('uploaddocument', fd).pipe(
      map(data => {
        return data;
      })
    )
  }

  getApplicantID() {
    return localStorage.getItem('wl-applicant-id');
  }


  getCrifState() {

    return of(this.states);
  }
  

  getretailLoan() {
    return of(this.retail_loan);
  }

  getfarmerLoan() {
    return of(this.farmer_loan);
  }

  getApplicationTypes() {
    return of(this.application_type);
  }


}
